import React from 'react'
import { Link } from 'react-router-dom';
import { Pagination } from '../Pagination'

export const ListItems = (props) => {

    const items = props.items;

    return (
        <>
            <div className="row">
                {!!items && items.map((item) => (
                    <div className="col-lg-12 col-md-12">
                        <div className="listing-item-container list-layout">
                            <Link to={`/item`} className="listing-item">

                                {/* <!-- Image --> */}
                                <div className="listing-item-image">
                                    <img  src={item.defaultImagePath} alt="" />
                                    <span className="tag">{item.tag}</span>
                                </div>

                                {/* <!-- Content --> */}
                                <div className="listing-item-content">
                                    {item.showNowOpen && (
                                        <div className="listing-badge now-open">Now Open</div>
                                    )}
                                    {item.showNowClosed && (
                                        <div className="listing-badge now-closed">Now Closed</div>
                                    )}

                                    <div className="listing-item-inner">
                                        <h3>{item.title} {item.verified && (
                                            <i className="verified-icon"></i>
                                        )}</h3>
                                        <span>{item.address}</span>
                                        <div className="star-rating" data-rating={item.rating}>
                                            <div className="rating-counter">({item.reviews} reviews)</div>
                                        </div>
                                    </div>
                                    {item.isFavorite ? (
                                        <span className="like-icon liked"></span>
                                    ) : (
                                        <span className="like-icon"></span>
                                    )}
                                </div>
                            </Link>
                        </div>
                    </div>
                ))}

               

            </div>
            <Pagination />
        </>
    )
}